/* global axios */
import ApiClient from './ApiClient';

class ConversationAttachmentsAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  get(conversationId, params = {}) {
    return axios.get(`${this.url}/${conversationId}/attachments`, { params });
  }

  show(conversationId, attachmentId) {
    return axios.get(
      `${this.url}/${conversationId}/attachments/${attachmentId}`
    );
  }

  create(conversationId, file, pipelineId = null) {
    const formData = new FormData();
    formData.append('file', file);
    if (pipelineId) {
      formData.append('pipeline_id', pipelineId);
    }

    return axios.post(`${this.url}/${conversationId}/attachments`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  bulkUpload(conversationId, files, pipelineId = null) {
    const formData = new FormData();
    files.forEach(file => {
      formData.append('files[]', file);
    });
    if (pipelineId) {
      formData.append('pipeline_id', pipelineId);
    }

    return axios.post(
      `${this.url}/${conversationId}/attachments/bulk_upload`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
  }

  delete(conversationId, attachmentId) {
    return axios.delete(
      `${this.url}/${conversationId}/attachments/${attachmentId}`
    );
  }

  download(conversationId, attachmentId) {
    return axios.get(
      `${this.url}/${conversationId}/attachments/${attachmentId}/download`
    );
  }
}

export default new ConversationAttachmentsAPI();
